import { C } from "../../constants/theme";

// Prévia das fotos trazidas do MakerWorld (data URLs de ~400 px).
//   previas === undefined -> ainda baixando; [] -> nenhuma veio (não mostra nada).
export function FaixaFotosMakerWorld({ previas, tamanho = 52 }) {
  if (previas === undefined) return <p style={{ margin:"6px 0", fontSize:12, color:C.muted }}>⏳ Carregando as fotos…</p>;
  if (!previas.length) return null;
  return (
    <div style={{ display:"flex", gap:6, flexWrap:"wrap", margin:"8px 0" }}>
      {previas.map((foto, i) => (
        <img key={i} src={foto} alt={`Foto ${i + 1} do MakerWorld`}
          style={{ width:tamanho, height:tamanho, objectFit:"cover", borderRadius:8, border:"1px solid " + C.border }} />
      ))}
    </div>
  );
}
